import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from 'src/app/modules/_models/field.interface';
@Component({
  selector: 'app-circle-progress',
  template: `
    <div
      [ngStyle]="field.styleDivPrincipal() ? field.styleDivPrincipal() : null"
      *ngIf="field.visible != null ? (!field.visible ? false : true) : true"
      [ngClass]="field.class ? field.class : null"
    >
      <div class="circle_progress_container">
        <div [ngStyle]="trufaStyle" *ngIf="field.circleProgress.exibeTrufa">
          <img
            class="progress_icon_trufa"
            src="assets/images/icons/trufa.png"
          />
        </div>
        <div class="cs_circle-label" *ngIf="field.circleProgress.exibeLegenda">
          <p class="cs_label cs_negrito">{{ field.circleProgress.value }}</p>
          <p class="cs_label cs_maxvalue">
            /{{ field.circleProgress.maxValue }}
          </p>
        </div>
        <div class="desafio" *ngIf="field.desafio">
          <p
            class="cs_label desafio__label"
            [ngStyle]="{ color: field.circleProgress.color }"
          >
            Desafio
          </p>
          <p class="cs_label desafio__nome" *ngIf="field.desafio.label">
            {{ field.desafio.label }}
          </p>
          <img
            *ngIf="field.desafio.src"
            class="desafio__imagem"
            [src]="field.desafio.src"
          />
          <button
            class="desafio__resgate"
            *ngIf="calcularPorcentagem() == 100"
            disabled
          >
            Concluído
          </button>
        </div>
        <circle-progress
          class="cs_circle-progress"
          [percent]="calcularPorcentagem()"
          [radius]="field.circleProgress.radius"
          [outerStrokeWidth]="field.circleProgress.sizeStroke"
          [outerStrokeColor]="field.circleProgress.color"
          [animation]="false"
          [responsive]="false"
          [showTitle]="false"
          [showSubtitle]="false"
          [showUnits]="false"
          [showInnerStroke]="true"
          [showImage]="true"
          [imageWidth]="70"
          [imageHeight]="70"
          [space]="0"
          [innerStrokeColor]="field.circleProgress.backgroundColor"
          [innerStrokeWidth]="field.circleProgress.sizeStroke"
          [backgroundPadding]="0"
          [imageSrc]="field.circleProgress.imageSrc"
          (click)="field.circleProgress.onClick()"
          [renderOnClick]="false"
          [backgroundColor]="field.circleProgress.backgroundColor"
          [outerStrokeLinecap]="'butt'"
          [backgroundStrokeWidth]="0"
        >
        </circle-progress>
      </div>
    </div>
  `,
  styleUrls: ['./circle-progress.component.scss'],
})
export class CircleProgressComponent implements OnInit {
  field: FieldConfig;
  @Input() fieldInput: FieldConfig;
  group: UntypedFormGroup;
  trufaStyle: object;
  constructor() {}
  ngOnInit(): void {
    if (this.fieldInput) this.field = this.fieldInput;
    this.carregarVariaveis();
    this.carregarTrufa();
  }
  carregarVariaveis(): void {
    if (!this.field.circleProgress.radius)
      this.field.circleProgress.radius = 35;
    if (!this.field.circleProgress.maxValue)
      this.field.circleProgress.maxValue = 100;
    if (!this.field.circleProgress.value) this.field.circleProgress.value = 0;
    if (!this.field.circleProgress.backgroundColor)
      this.field.circleProgress.backgroundColor = 'transparent';
    if (!this.field.circleProgress.sizeStroke)
      this.field.circleProgress.sizeStroke = 6;
  }
  calcularPorcentagem(): number {
    var porcentagem: number = 0;
    if (this.field.circleProgress.porcent)
      porcentagem = this.field.circleProgress.porcent;
    else
      var porcentagem =
        (this.field.circleProgress.value * 100) /
        this.field.circleProgress.maxValue;
    if (porcentagem > 100) porcentagem = 100;
    return porcentagem;
  }
  carregarTrufa(): void {
    var rotatePorcentagem = (this.calcularPorcentagem() * 36) / 10;
    this.trufaStyle = {
      width: '3px',
      height: '65px',
      position: 'absolute',
      'margin-left': '50px',
      transform: 'rotate(' + rotatePorcentagem + 'deg)',
      'margin-top': '17px',
    };
  }
}
